/**
 * Mock switch ports for the Switch Ports page.
 * 24 ports — mostly access on various VLANs, two trunks at the end, a
 * couple of disabled ports, and one with a CDP neighbor.
 */
import type { SwitchPort } from "@/api/schemas/meraki";

const SERIAL = "Q2HW-K3LM-NNNN";
const NAME = "MS425-core-08";

export const MOCK_SWITCH_PORTS: SwitchPort[] = Array.from({ length: 24 }, (_, i) => {
  const portId = String(i + 1);

  // Establish per-port "personality" via simple math — gives the table some variety.
  const isUplink = i >= 22; // ports 23 + 24 = trunks
  const isDisabled = i === 4 || i === 19; // ports 5 + 20 disabled
  const vlan = isUplink ? null : [10, 20, 30, 40, 50, 60][i % 6] ?? null;

  return {
    portId,
    deviceSerial: SERIAL,
    deviceName: NAME,
    type: isUplink ? "trunk" : "access",
    vlan: vlan === null ? null : String(vlan),
    allowedVlans: isUplink ? "all" : null,
    enabled: !isDisabled,
    name: i === 0 ? "uplink-att" : i === 1 ? "uplink-spectrum" : null,
    tags: isUplink ? ["uplink"] : ["edge"],
    neighbor:
      i === 22
        ? { systemName: "edge-router-01", portId: "Gi0/0/1" }
        : i === 23
          ? { systemName: "edge-router-02", portId: "Gi0/0/1" }
          : null,
  };
}) as SwitchPort[];
